import React, { useEffect, useState } from "react";
import {Spin, Tooltip } from "antd";
import SectionHeader from "../../components/global/SectionHeader";
import moment from "moment";
import { useNavigate, useParams } from "react-router";
import Layout from "../../components/global/layout";
import { BsArrowLeftSquare } from "react-icons/bs";
import ApiClient from "../../methods/api/apiClient";
const AssignEmployeeView = (props) => {
let {id}=useParams()
console.log(id);

  const [clientNames, setClientName] = useState();
  const [status, setStatus] = useState();
  const [loading, setloading] = useState(false);
  const [data, setData] = useState(false);


  useEffect(() => {
    getEmployeeAssigned();
  }, []);

  const getEmployeeAssigned = async (i) => {
    setloading(true);
    ApiClient.allApi('getProjectMembers?id='+id,{}).then((res)=>{
   if(res.success){
    setloading(false);
    setData(res.data)
   } else{
    setloading(false);
   }
    })
  };
  const navigate = useNavigate();
 
  const renderSubmitBack = () => {
    navigate(-1);
  };
  return (
    <Layout>
      <div className="">
        <div className="headings">
          <div className="d-flex align-items-center gap-3">
            <Tooltip title="Back Button">
              <p onClick={renderSubmitBack} className="pointer text-white  fs-3">
                <BsArrowLeftSquare />
              </p>
            </Tooltip>
            <SectionHeader title="Assign Projects Details" />
          </div>
        </div>

        <Spin spinning={loading}>
          <div className="">
            <div className="">
              <div class="row">
                <div class="col-md-4">
                  <div className="project_deatil">
                    <div className="label_heading">
                      <label className="text-bold">Project Name:</label>
                    </div>
                    <div className="label_text">
                      <span> {data?.projectDetails?.name}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div className="project_deatil">
                    <div className="label_heading">
                      <label className="text-bold">Project Status:</label>
                    </div>
                    <div className="label_text">
                      <span> {data?.projectDetails?.projectStatus}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div className="project_deatil">
                    <div className="label_heading">
                      <label className="text-bold">Project Start Date:</label>
                    </div>
                    <div className="label_text">
                      <span> {data?.projectDetails?.startDate}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div className="project_deatil">
                    <div className="label_heading">
                      <label className="text-bold">Assign Project Members</label>
                    </div>
                    <div className="label_text">
                      <span> 
                        
                        {data?.members && data.members?.length?
                        data.members.map((res,index)=>{

return(<>
  <span> 
  {res.fullName}{index !== data.members.length - 1 && ', '}
    </span>
</>)
                        }):'No member assign yet'

                      


                        }
                 
                        
                        </span>
                    </div>
                  </div>
                </div>
       
               
           

              </div>
            </div>
          </div>
        </Spin>
      </div>
    </Layout>
  );
};

export default AssignEmployeeView;
